import { createClient } from "@supabase/supabase-js";

/**
 * Supabase client - wspolny projekt z v1 (Strangler Fig).
 *
 * Obsluguje obie nazwy klucza dla backward compat z v1 .env conventions:
 *   - VITE_SUPABASE_PUBLISHABLE_KEY (nowy Supabase naming, sb_publishable_* format)
 *   - VITE_SUPABASE_ANON_KEY (legacy JWT anon key eyJ...)
 *
 * Pierwsze wykryte uzywane, fallback do drugiego.
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_KEY =
  (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined) ??
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined);

if (!SUPABASE_URL || !SUPABASE_KEY) {
  throw new Error(
    "[supabase] Brak VITE_SUPABASE_URL lub VITE_SUPABASE_PUBLISHABLE_KEY (alt: VITE_SUPABASE_ANON_KEY) w env. " +
    "Skopiuj .env.example -> .env i wypelnij wartosci z Supabase Dashboard -> Settings -> API.",
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "adresflow-v2-auth",
  },
});
